import { useDispatch, useSelector } from "react-redux";
import { Button, Checkbox, Input } from "semantic-ui-react";
import { transactionExpressForInput } from "../../../regex_constanst";
import { useTranslation } from "react-i18next";
import { bankWithdraw } from "../../../api/postApi";
import { useEffect, useMemo, useState } from "react";
import { notice } from "../../../redux/action/action";
import { useNavigate } from "react-router";
import WithdrawNotice from "./withdrawNotice";
import { WITHDRAW_AMOUNT_MIN } from "../../../constant";
import { formatNumber } from "../../../utils/formatNumber";
import WithdrawTerm from "./withdrawTerm";
import { getDepositPaymentList } from "../../../api/getApi";
import ErrorHint from "../../../components/Hint/ErrorHint";
import FromWithdrawHint from "./fromWithdrawHint";

const BankWithdraw = ({ washConfig }) => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`settings.${key}`, { ...props });
  const i18n_deposit = (key, props) => t(`deposit.${key}`, { ...props });

  const memberData = useSelector((state) => state.isMemberInfo);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [buttonLoading, setButtonLoading] = useState(false);
  const [data, setData] = useState({
    amounts: 0,
    secret_pwd: "",
    understand: false,
  });
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const { amounts, secret_pwd, understand } = data;

  const washPointMemo = useMemo(() => {
    const { washPoint, betAmount } = washConfig;
    const withdrawStatus = betAmount >= washPoint; //是否達到洗碼條件 true:達到 false:未達到
    return {
      canWithdraw: withdrawStatus,
      hint: i18n(`withdrawWashPoint`, {
        betAmount: formatNumber(betAmount, { point: false }),
        washPoint: formatNumber(washPoint, { point: false }),
      }),
    };
  }, [washConfig]);

  const { blank_name, blank_num2, blank_ea1, blank_num } =
    memberData?.bankAccount || {};

  //blank_num 銀行帳號
  //blank_num2 銀行卡號

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (amounts > memberData.vpoint) {
    //   dispatch(notice("提款金額不可大於餘額", "error"));
    //   return;
    // }
    setButtonLoading(true);
    bankWithdraw({
      amounts: amounts,
      bank_card_number: blank_num2,
      bank_name: blank_name,
      bank_branch: blank_ea1,
      bank_account: blank_num,
      secret_pwd: secret_pwd,
    })
      .then((data) => {
        dispatch(notice(i18n("withdrawalSuccess"), "success"));
        dispatch({ type: "GET_BALANCE" });
        navigate("withdraw-success");
      })
      .catch((err) => {})
      .finally(() => {
        setButtonLoading(false);
      });
  };
  const form = [
    {
      label: i18n("BankName"),
      name: "bank_name",
      disabled: true,
      value: blank_name,
    },
    {
      label: i18n("BankCard"),
      name: "bank_card_number",
      disabled: true,
      value: blank_num2,
    },
    {
      label: i18n("BankBranch"),
      name: "bank_branch",
      disabled: true,
      value: blank_ea1,
    },
    {
      label: i18n("BankAccount"),
      name: "bank_account",
      disabled: true,
      value: blank_num,
    },
    {
      label: i18n("amount"),
      name: "amount",
      type: "number",
      placeholder: i18n("atLeast50000", {
        min_amount: formatNumber(WITHDRAW_AMOUNT_MIN, { point: false }),
      }),
      min: WITHDRAW_AMOUNT_MIN,
      onChange: (e) => {
        setData({ ...data, amounts: e.target.value });
      },
    },
    {
      label: i18n("withdrawalPassword"),
      type: "password",
      name: "secret_pwd",
      placeholder: i18n("idCard.setTransactionPasswordHint"),
      title: i18n("idCard.setTransactionPasswordHint"),
      pattern: transactionExpressForInput,
      onChange: (e) => {
        setData({ ...data, secret_pwd: e.target.value });
      },
    },
  ];
  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-[10px]">
      <p className="text-center text-transaction-text dark:text-base-light-white my-[20px]">
        {i18n("Enter withdrawal information")}{" "}
      </p>
      <FromWithdrawHint washConfig={washConfig} />
      <WithdrawNotice />

      {form.map((item) => {
        return (
          <section>
            <span className="text-transaction-text dark:text-base-light-white">
              {item.label}
            </span>
            <Input disabled={item.disabled} size="middle" className="w-full">
              <input
                {...item}
                className="!bg-transaction-card dark:!bg-base-light-dark !text-transaction-text dark:!text-base-light-white"
                name={item.name}
                type={item.type || "text"}
              />
            </Input>
          </section>
        );
      })}
      <Checkbox
        onChange={(e, event) => {
          setData({ ...data, understand: event.checked });
        }}
        label={{
          children: (
            <span className="dark:text-base-light-white">
              {i18n_deposit("iUnderstand")}{" "}
              <span
                onClick={() => {
                  setOpenTermsModal(true);
                }}
                className="underline text-blue-500 cursor-pointer"
              >
                {i18n_deposit("withdrawTerms")}
              </span>
            </span>
          ),
        }}
      />
      {!washPointMemo?.canWithdraw && (
        <ErrorHint>{washPointMemo?.hint}</ErrorHint>
      )}
      <section>
        <Button
          loading={buttonLoading}
          disabled={
            !amounts ||
            !secret_pwd ||
            buttonLoading ||
            !understand ||
            !washPointMemo?.canWithdraw
          }
          size="big"
          type="submit"
          className="!bg-main-color !text-white w-full !mt-[10px] "
        >
          {i18n("Submit")}
        </Button>
      </section>
      {openTermsModal && <WithdrawTerm setOpenTermsModal={setOpenTermsModal} />}
    </form>
  );
};

export default BankWithdraw;
